import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { iconSize } from '../../../../constants/icon.constants';
import { BackToTopProps } from './types/backToTop.types';
import { windowService } from '../../../../utils/window.utils';
import './styles.scss';
import Icon from '../../../@shared/icon';

const BackToTop: FC<BackToTopProps> = ({ field }) => {
  const onClick = (): void => windowService().scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="back-to-top" onClick={onClick}>
      <Text tag="p" field={field} className="back-to-top__text" />
      <button className="back-to-top__button" type="button">
        <Icon iconName="arrow-chevron-up" size={iconSize.xlg} extraClassName="back-to-top__button--icon" />
      </button>
    </div>
  );
};

export default BackToTop;
